import { PartialBusinessEntityOptions } from "../../../lib/libby/generator";

export const businessOptions: { [k: string]: PartialBusinessEntityOptions<any> } = {};
